// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3Csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"2em\" height=\"2em\" viewBox=\"0 0 16 16\"%3E%3Cpath fill=\"none\" stroke=\"%23666666\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5\" d=\"M11 1l-6 6 6 6\"/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;charset=UTF-8,%3Csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"2em\" height=\"2em\" viewBox=\"0 0 16 16\"%3E%3Cpath fill=\"none\" stroke=\"%23666666\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5\" d=\"M5 1l6 6-6 6\"/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml;charset=UTF-8,%3Csvg xmlns=\"http://www.w3.org/2000/svg\" fill=\"%23666666\" viewBox=\"0 0 16 16\"%3E%3Cpath d=\"M5.854 1.146a.5.5 0 0 1 0 .708L1.707 6h12.586a.5.5 0 0 1 0 1H1.707l4.147 4.146a.5.5 0 0 1-.708.708l-5-5a.5.5 0 0 1 0-.708l5-5a.5.5 0 0 1 .708 0z\"/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../img/oficinas.jpeg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Catamaran:wght@400;500;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Importación de la fuente Catamaran */

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: 'Catamaran', sans-serif;
  font-weight: 700;
  /* o 600, 500, etc. */
}

p,
li,
a,
span {
  font-family: 'Catamaran', sans-serif;
  font-weight: 400;
}

body {
  font-family: 'Catamaran', sans-serif;
  color: #444;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.icon-custom-color {
  color: #0085CA;
}


/* Estilo personalizado del botón */
.btn-custom {
  background-color: #0085CA;
  /* Color de fondo */
  color: white;
  /* Color del texto */
  padding: 8px 16px;
  /* Tamaño del botón */
  border-radius: 5px;
  /* Bordes redondeados */
  text-decoration: none;
  /* Quitar subrayado */
  transition: background-color 0.3s ease;
}

.btn-custom:hover {
  background-color: #064587;
  /* Color en hover */
  text-decoration: none;
}

/* Ajustes generales para iconos más pequeños */
.icon {
  font-size: 24px;
  /* Ajusta el tamaño del icono */
}


.carousel-control-prev-icon,
.carousel-control-next-icon {
  background-color: rgba(255, 255, 255, 0.9);
  /* Fondo blanco para los íconos */
  width: 30px;
  height: 30px;
  border-radius: 50%;
  /* Hace los íconos circulares */
}

/* Define los íconos de las flechas en gris */
.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  background-size: 100% 100%;
  /* Asegura que los íconos llenen el área disponible */
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: 100% 100%;
  /* Ajusta el tamaño del ícono */
  background-color: transparent;
  /* Sin fondo para el ícono */
  width: 30px;
  /* Ajusta el tamaño según sea necesario */
  height: 30px;
  /* Ajusta el tamaño según sea necesario */
}

a {
  text-decoration: none;
  color: inherit;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

.section {
  padding: 60px 0;
}

.text-center {
  text-align: center;
}

/* Estilo base para el botón interactivo */
.interactive-button {
  background-color: #0085CA;
  /* Color azul base */
  color: white;
  /* Texto en blanco */
  padding: 5px 10px;
  /* Tamaño pequeño */
  font-size: 16px;
  /* Fuente más pequeña */
  border: none;
  border-radius: 5px;
  /* Bordes redondeados */
  cursor: pointer;
  /* Cambia el cursor a pointer */
  transition: background-color 0.3s ease, transform 0.2s ease;
  /* Transiciones suaves */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  /* Sombra sutil */
  margin-top: 10px;
}

/* Efecto hover: cambio de color y ligera animación */
.interactive-button:hover {
  background-color: #0085CA;
  /* Color más oscuro en hover */
  transform: translateY(-2px);
  /* Efecto de elevar el botón */
}

/* Efecto cuando el botón está presionado */
.interactive-button:active {
  transform: translateY(0);
  /* Vuelve a su lugar original */
  background-color: #0085CA;
  /* Color más oscuro al hacer clic */
}

/* Estilo para el párrafo de beneficios */
.benefits {
  margin-top: 10px;

  color: #0085CA;
  text-align: justify;
}


/* Hero Section */
.hero {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30vh;
  background: none;
  /* Quitamos el fondo anterior */
  color: white;
  text-align: justify;
}

.hero::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat center;
  background-size: cover;
  z-index: -1;
  /* Colocamos la imagen detrás de todo */
}

.disabled-link {
  pointer-events: none;
  /* Deshabilita los clics */
  color: gray;
  /* Color gris para dar indicación visual */
  cursor: not-allowed;
  /* Cursor de "no permitido" */
}


.hero::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(17, 32, 35, 0.522);
  /* Capa azul con 20% de opacidad */
  z-index: -1;
  /* Colocamos la capa azul detrás del contenido pero delante de la imagen */
}


.hero h1 {
  font-size: 48px;
  font-weight: 700;
  margin-bottom: 20px;
}

.hero p {
  font-size: 18px;
  margin-bottom: 30px;
}


.hero .btn-get-started {
  background: #380404;
  color: #000000;
  padding: 10px 30px;
  border-radius: 50px;
  font-size: 16px;
  font-weight: bold;
  transition: 0.3s;
}

.hero .btn-get-started:hover {
  background: #ffffff;
  color: #fff;
}

.hero-img img {
  max-width: 100%;
  animation: floating 3s ease-in-out infinite;
}

@keyframes floating {

  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-10px);
  }
}

/* Services Section */
.services {
  background-color: #f9f9f9;
}

.section-title h2 {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 20px;
  color: #01111a;
}

.section-title p {
  font-size: 16px;
  color: #666;
}

/* Estilo personalizado para el botón de Instructivo */
.btn-instructivo {
  background-color: #0085CA;
  /* Color de fondo */
  color: white;
  /* Color del texto */
  padding: 3px 10px;
  /* Tamaño del botón */
  font-size: 12px;
  /* Tamaño de la fuente */
  border: 2px solid transparent;
  /* Borde sin color por defecto */
  border-radius: 8px;


  text-align: center;
  /* Alineación del texto */
  text-decoration: none;
  /* Sin subrayado */

}

.btn-instructivo:hover {
  background-color: #064587;
  /* Cambio de color en hover */
  color: #fff;
  /* Mantener el color del texto */
  border: 2px solid #fff;
  /* Agregar borde blanco al hacer hover */
  transform: scale(1.05);
  /* Efecto de agrandar al hacer hover */
}

.btn-instructivo:active {
  transform: scale(0.98);
  /* Efecto cuando se presiona */
  background-color: #043d6a;
  /* Color más oscuro cuando se hace clic */
}

.btn-custom:hover {
  background-color: #064587;
  /* Color en hover */
  text-decoration: none;
}

.service-item .icon {
  font-size: 20px;
  color: #000000;
  margin-bottom: 20px;
}

.service-item h4 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 15px;
  color: #ffffff;
}

.service-item p {
  font-size: 14px;
  color: #666;
}

/* Footer */
.footer {
  background: #0664f2;
  padding: 30px 0;
  color: white;
  text-align: center;
}

.footer a {
  color: #2575fc;
  text-decoration: none;
}

.footer a:hover {
  text-decoration: underline;
}

/* Scroll to Top */
.scroll-top {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color: #2575fc;
  color: white;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 0.3s;
  display: none;
}

.scroll-top:hover {
  background-color: #ffffff;
}

.scroll-top i {
  font-size: 24px;
}

/* Media Queries */
@media (max-width: 991px) {
  .hero h1 {
    font-size: 36px;
  }

  .hero p {
    font-size: 16px;
  }

  .services .row .col-md-6 {
    margin-bottom: 30px;
  }
}

.row {
  display: flex;
  flex-wrap: wrap;
}

.service-item {
  flex-basis: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.row {
  display: flex;
  flex-wrap: wrap;
}

.main {
  position: relative;
  background: none;
  /* Quitamos el background aquí */
}

.main::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat center;
  background-size: cover;
  /* Ajustamos el tamaño de la imagen */
  opacity: 0.1;
  /* Aplicamos opacidad solo a la imagen de fondo */
  z-index: -1;
  /* La imagen se mantiene detrás del contenido */
}

/* Resto de los estilos se mantienen */


@media (max-width: 768px) {
  .hero h1 {
    font-size: 28px;
  }

  .hero p {
    font-size: 14px;
  }

  .service-item {
    padding: 20px;
  }
}

@media (max-width: 576px) {
  .hero h1 {
    font-size: 24px;
  }

  .hero p {
    font-size: 12px;
  }

  .hero .btn-get-started {
    padding: 8px 20px;
    font-size: 14px;
  }

  .service-item h4 {
    font-size: 18px;
  }

  .service-item p {
    font-size: 12px;
  }
}

nav ul {
  list-style-type: none;
  padding: 0;
}

nav ul li {
  display: inline;
  margin-right: 20px;
}

nav ul li a {
  text-decoration: none;
  color: #ffffff;
}

nav ul li a:hover {
  text-decoration: underline;
}

/* Contenedor principal del menú */
.menu-container {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 9999;
  /* Asegurarse de que el menú esté por encima de otros elementos */
}

/* Botón del menú */
.menu-button {
  background-color: #007bff;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.menu-button:hover {
  background-color: #0056b3;
  /* Cambiar color al pasar el ratón */
}

/* Estilos para el botón cuando el menú está abierto */
.menu-button.open {
  background-color: #dc3545;
  /* Cambiar a rojo cuando está abierto */
}

.menu-button svg {
  color: white;
  font-size: 1.5rem;
}

/* Estilos para los elementos del menú */
.menu-items {
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  opacity: 0;
  transform: translateY(-20px);
  transition: all 0.3s ease;
  pointer-events: none;
  /* Evita clics cuando está cerrado */
  padding: 20px;
  position: absolute;
  right: 0;
  top: 70px;
  width: 200px;
  display: flex;
  flex-direction: column;
}

.menu-items.open {
  opacity: 1;
  transform: translateY(0);
  pointer-events: auto;
}

.menu-item {
  padding: 10px 0;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.menu-item:hover {
  background-color: #f8f9fa;
  border-radius: 5px;
}

.menu-item svg {
  margin-right: 10px;
  font-size: 1.2rem;
  color: #007bff;
}

.menu-item span {
  font-size: 1rem;
  color: #343a40;
}

/* Responsive: Adaptación para pantallas pequeñas */
@media (max-width: 768px) {
  .menu-container {
    top: 10px;
    right: 10px;
  }

  .menu-button {
    width: 50px;
    height: 50px;
  }

  .menu-items {
    width: 150px;
    top: 60px;
  }
}

/* Estilo general para los botones */
.btn-custom {
  background-color: #007bff;
  /* Azul bootstrap */
  color: #fff;
  border-radius: 50px;
  /* Borde redondeado */
  padding: 10px 20px;
  /* Espaciado interno del botón */
  font-size: 16px;
  /* Tamaño de la fuente */
  border: none;
  /* Sin borde */
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
}

/* Hover: cambia el color cuando pasas el mouse sobre el botón */
.btn-custom:hover {
  background-color: #0056b3;
  /* Azul más oscuro */
  transform: scale(1.05);
  /* Aumenta un poco el tamaño */
}

/* Estilo para botones dentro de los nav-items */
.nav-item .btn-custom {
  margin-right: 10px;
  /* Espaciado entre botones en el menú */
  text-decoration: none;
  /* Elimina el subrayado */
  display: inline-block;
}`, "",{"version":3,"sources":["webpack://./src/components/assets/css/main.css"],"names":[],"mappings":"AAAA,uCAAuC;;AAGvC;;;;;;EAME,oCAAoC;EACpC,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;;;EAIE,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;;AAGA,mCAAmC;AACnC;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;EACrB,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,+CAA+C;AAC/C;EACE,eAAe;EACf,+BAA+B;AACjC;;;AAGA;;EAEE,0CAA0C;EAC1C,iCAAiC;EACjC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA,6CAA6C;AAC7C;EACE,yDAA4R;AAC9R;;AAEA;EACE,yDAA0R;AAC5R;;AAEA;;EAEE,0BAA0B;EAC1B,qDAAqD;AACvD;;AAEA;EACE,yDAAqT;EACrT,0BAA0B;EAC1B,+BAA+B;EAC/B,6BAA6B;EAC7B,4BAA4B;EAC5B,WAAW;EACX,yCAAyC;EACzC,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,0CAA0C;AAC1C;EACE,yBAAyB;EACzB,oBAAoB;EACpB,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,+BAA+B;EAC/B,2DAA2D;EAC3D,wBAAwB;EACxB,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,qDAAqD;AACrD;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA,2CAA2C;AAC3C;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA,yCAAyC;AACzC;EACE,gBAAgB;;EAEhB,cAAc;EACd,mBAAmB;AACrB;;;AAGA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,+BAA+B;EAC/B,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oEAAwD;EACxD,sBAAsB;EACtB,WAAW;EACX,uCAAuC;AACzC;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,WAAW;EACX,0CAA0C;EAC1C,mBAAmB;EACnB,6BAA6B;AAC/B;;;AAGA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,kCAAkC;EAClC,WAAW;EACX,0EAA0E;AAC5E;;;AAGA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;;AAGA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,2CAA2C;AAC7C;;AAEA;;EAEE;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA,qBAAqB;AACrB;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,sDAAsD;AACtD;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;EACf,wBAAwB;EACxB,6BAA6B;EAC7B,gCAAgC;EAChC,kBAAkB;;;EAGlB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;;AAEpB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,WAAW;EACX,gCAAgC;EAChC,sBAAsB;EACtB,wCAAwC;EACxC,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oEAAwD;EACxD,sBAAsB;EACtB,qCAAqC;EACrC,YAAY;EACZ,iDAAiD;EACjD,WAAW;EACX,+CAA+C;AACjD;;AAEA,sCAAsC;;;AAGtC;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,kCAAkC;AAClC;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,aAAa;EACb,iEAAiE;AACnE;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,sCAAsC;EACtC,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA,sDAAsD;AACtD;EACE,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA,wCAAwC;AACxC;EACE,uBAAuB;EACvB,mBAAmB;EACnB,yCAAyC;EACzC,UAAU;EACV,4BAA4B;EAC5B,yBAAyB;EACzB,oBAAoB;EACpB,oCAAoC;EACpC,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,mDAAmD;AACnD;EACE;IACE,SAAS;IACT,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,SAAS;EACX;AACF;;AAEA,oCAAoC;AACpC;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,wBAAwB;EACxB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,2DAA2D;AAC7D;;AAEA,gEAAgE;AAChE;EACE,yBAAyB;EACzB,oBAAoB;EACpB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA,gDAAgD;AAChD;EACE,kBAAkB;EAClB,uCAAuC;EACvC,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;AACvB","sourcesContent":["/* Importación de la fuente Catamaran */\n@import url('https://fonts.googleapis.com/css2?family=Catamaran:wght@400;500;700&display=swap');\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: 'Catamaran', sans-serif;\n  font-weight: 700;\n  /* o 600, 500, etc. */\n}\n\np,\nli,\na,\nspan {\n  font-family: 'Catamaran', sans-serif;\n  font-weight: 400;\n}\n\nbody {\n  font-family: 'Catamaran', sans-serif;\n  color: #444;\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.icon-custom-color {\n  color: #0085CA;\n}\n\n\n/* Estilo personalizado del botón */\n.btn-custom {\n  background-color: #0085CA;\n  /* Color de fondo */\n  color: white;\n  /* Color del texto */\n  padding: 8px 16px;\n  /* Tamaño del botón */\n  border-radius: 5px;\n  /* Bordes redondeados */\n  text-decoration: none;\n  /* Quitar subrayado */\n  transition: background-color 0.3s ease;\n}\n\n.btn-custom:hover {\n  background-color: #064587;\n  /* Color en hover */\n  text-decoration: none;\n}\n\n/* Ajustes generales para iconos más pequeños */\n.icon {\n  font-size: 24px;\n  /* Ajusta el tamaño del icono */\n}\n\n\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  background-color: rgba(255, 255, 255, 0.9);\n  /* Fondo blanco para los íconos */\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  /* Hace los íconos circulares */\n}\n\n/* Define los íconos de las flechas en gris */\n.carousel-control-prev-icon {\n  background-image: url('data:image/svg+xml;charset=UTF-8,%3Csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"2em\" height=\"2em\" viewBox=\"0 0 16 16\"%3E%3Cpath fill=\"none\" stroke=\"%23666666\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5\" d=\"M11 1l-6 6 6 6\"/%3E%3C/svg%3E');\n}\n\n.carousel-control-next-icon {\n  background-image: url('data:image/svg+xml;charset=UTF-8,%3Csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"2em\" height=\"2em\" viewBox=\"0 0 16 16\"%3E%3Cpath fill=\"none\" stroke=\"%23666666\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5\" d=\"M5 1l6 6-6 6\"/%3E%3C/svg%3E');\n}\n\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  background-size: 100% 100%;\n  /* Asegura que los íconos llenen el área disponible */\n}\n\n.carousel-control-next-icon {\n  background-image: url('data:image/svg+xml;charset=UTF-8,%3Csvg xmlns=\"http://www.w3.org/2000/svg\" fill=\"%23666666\" viewBox=\"0 0 16 16\"%3E%3Cpath d=\"M5.854 1.146a.5.5 0 0 1 0 .708L1.707 6h12.586a.5.5 0 0 1 0 1H1.707l4.147 4.146a.5.5 0 0 1-.708.708l-5-5a.5.5 0 0 1 0-.708l5-5a.5.5 0 0 1 .708 0z\"/%3E%3C/svg%3E');\n  background-size: 100% 100%;\n  /* Ajusta el tamaño del ícono */\n  background-color: transparent;\n  /* Sin fondo para el ícono */\n  width: 30px;\n  /* Ajusta el tamaño según sea necesario */\n  height: 30px;\n  /* Ajusta el tamaño según sea necesario */\n}\n\na {\n  text-decoration: none;\n  color: inherit;\n}\n\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 15px;\n}\n\n.section {\n  padding: 60px 0;\n}\n\n.text-center {\n  text-align: center;\n}\n\n/* Estilo base para el botón interactivo */\n.interactive-button {\n  background-color: #0085CA;\n  /* Color azul base */\n  color: white;\n  /* Texto en blanco */\n  padding: 5px 10px;\n  /* Tamaño pequeño */\n  font-size: 16px;\n  /* Fuente más pequeña */\n  border: none;\n  border-radius: 5px;\n  /* Bordes redondeados */\n  cursor: pointer;\n  /* Cambia el cursor a pointer */\n  transition: background-color 0.3s ease, transform 0.2s ease;\n  /* Transiciones suaves */\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  /* Sombra sutil */\n  margin-top: 10px;\n}\n\n/* Efecto hover: cambio de color y ligera animación */\n.interactive-button:hover {\n  background-color: #0085CA;\n  /* Color más oscuro en hover */\n  transform: translateY(-2px);\n  /* Efecto de elevar el botón */\n}\n\n/* Efecto cuando el botón está presionado */\n.interactive-button:active {\n  transform: translateY(0);\n  /* Vuelve a su lugar original */\n  background-color: #0085CA;\n  /* Color más oscuro al hacer clic */\n}\n\n/* Estilo para el párrafo de beneficios */\n.benefits {\n  margin-top: 10px;\n\n  color: #0085CA;\n  text-align: justify;\n}\n\n\n/* Hero Section */\n.hero {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 30vh;\n  background: none;\n  /* Quitamos el fondo anterior */\n  color: white;\n  text-align: justify;\n}\n\n.hero::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: url(\"../img/oficinas.jpeg\") no-repeat center;\n  background-size: cover;\n  z-index: -1;\n  /* Colocamos la imagen detrás de todo */\n}\n\n.disabled-link {\n  pointer-events: none;\n  /* Deshabilita los clics */\n  color: gray;\n  /* Color gris para dar indicación visual */\n  cursor: not-allowed;\n  /* Cursor de \"no permitido\" */\n}\n\n\n.hero::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(17, 32, 35, 0.522);\n  /* Capa azul con 20% de opacidad */\n  z-index: -1;\n  /* Colocamos la capa azul detrás del contenido pero delante de la imagen */\n}\n\n\n.hero h1 {\n  font-size: 48px;\n  font-weight: 700;\n  margin-bottom: 20px;\n}\n\n.hero p {\n  font-size: 18px;\n  margin-bottom: 30px;\n}\n\n\n.hero .btn-get-started {\n  background: #380404;\n  color: #000000;\n  padding: 10px 30px;\n  border-radius: 50px;\n  font-size: 16px;\n  font-weight: bold;\n  transition: 0.3s;\n}\n\n.hero .btn-get-started:hover {\n  background: #ffffff;\n  color: #fff;\n}\n\n.hero-img img {\n  max-width: 100%;\n  animation: floating 3s ease-in-out infinite;\n}\n\n@keyframes floating {\n\n  0%,\n  100% {\n    transform: translateY(0);\n  }\n\n  50% {\n    transform: translateY(-10px);\n  }\n}\n\n/* Services Section */\n.services {\n  background-color: #f9f9f9;\n}\n\n.section-title h2 {\n  font-size: 32px;\n  font-weight: 700;\n  margin-bottom: 20px;\n  color: #01111a;\n}\n\n.section-title p {\n  font-size: 16px;\n  color: #666;\n}\n\n/* Estilo personalizado para el botón de Instructivo */\n.btn-instructivo {\n  background-color: #0085CA;\n  /* Color de fondo */\n  color: white;\n  /* Color del texto */\n  padding: 3px 10px;\n  /* Tamaño del botón */\n  font-size: 12px;\n  /* Tamaño de la fuente */\n  border: 2px solid transparent;\n  /* Borde sin color por defecto */\n  border-radius: 8px;\n\n\n  text-align: center;\n  /* Alineación del texto */\n  text-decoration: none;\n  /* Sin subrayado */\n\n}\n\n.btn-instructivo:hover {\n  background-color: #064587;\n  /* Cambio de color en hover */\n  color: #fff;\n  /* Mantener el color del texto */\n  border: 2px solid #fff;\n  /* Agregar borde blanco al hacer hover */\n  transform: scale(1.05);\n  /* Efecto de agrandar al hacer hover */\n}\n\n.btn-instructivo:active {\n  transform: scale(0.98);\n  /* Efecto cuando se presiona */\n  background-color: #043d6a;\n  /* Color más oscuro cuando se hace clic */\n}\n\n.btn-custom:hover {\n  background-color: #064587;\n  /* Color en hover */\n  text-decoration: none;\n}\n\n.service-item .icon {\n  font-size: 20px;\n  color: #000000;\n  margin-bottom: 20px;\n}\n\n.service-item h4 {\n  font-size: 20px;\n  font-weight: 600;\n  margin-bottom: 15px;\n  color: #ffffff;\n}\n\n.service-item p {\n  font-size: 14px;\n  color: #666;\n}\n\n/* Footer */\n.footer {\n  background: #0664f2;\n  padding: 30px 0;\n  color: white;\n  text-align: center;\n}\n\n.footer a {\n  color: #2575fc;\n  text-decoration: none;\n}\n\n.footer a:hover {\n  text-decoration: underline;\n}\n\n/* Scroll to Top */\n.scroll-top {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  background-color: #2575fc;\n  color: white;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: 0.3s;\n  display: none;\n}\n\n.scroll-top:hover {\n  background-color: #ffffff;\n}\n\n.scroll-top i {\n  font-size: 24px;\n}\n\n/* Media Queries */\n@media (max-width: 991px) {\n  .hero h1 {\n    font-size: 36px;\n  }\n\n  .hero p {\n    font-size: 16px;\n  }\n\n  .services .row .col-md-6 {\n    margin-bottom: 30px;\n  }\n}\n\n.row {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.service-item {\n  flex-basis: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n.row {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.main {\n  position: relative;\n  background: none;\n  /* Quitamos el background aquí */\n}\n\n.main::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: url(\"../img/oficinas.jpeg\") no-repeat center;\n  background-size: cover;\n  /* Ajustamos el tamaño de la imagen */\n  opacity: 0.1;\n  /* Aplicamos opacidad solo a la imagen de fondo */\n  z-index: -1;\n  /* La imagen se mantiene detrás del contenido */\n}\n\n/* Resto de los estilos se mantienen */\n\n\n@media (max-width: 768px) {\n  .hero h1 {\n    font-size: 28px;\n  }\n\n  .hero p {\n    font-size: 14px;\n  }\n\n  .service-item {\n    padding: 20px;\n  }\n}\n\n@media (max-width: 576px) {\n  .hero h1 {\n    font-size: 24px;\n  }\n\n  .hero p {\n    font-size: 12px;\n  }\n\n  .hero .btn-get-started {\n    padding: 8px 20px;\n    font-size: 14px;\n  }\n\n  .service-item h4 {\n    font-size: 18px;\n  }\n\n  .service-item p {\n    font-size: 12px;\n  }\n}\n\nnav ul {\n  list-style-type: none;\n  padding: 0;\n}\n\nnav ul li {\n  display: inline;\n  margin-right: 20px;\n}\n\nnav ul li a {\n  text-decoration: none;\n  color: #ffffff;\n}\n\nnav ul li a:hover {\n  text-decoration: underline;\n}\n\n/* Contenedor principal del menú */\n.menu-container {\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  z-index: 9999;\n  /* Asegurarse de que el menú esté por encima de otros elementos */\n}\n\n/* Botón del menú */\n.menu-button {\n  background-color: #007bff;\n  border-radius: 50%;\n  width: 60px;\n  height: 60px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.menu-button:hover {\n  background-color: #0056b3;\n  /* Cambiar color al pasar el ratón */\n}\n\n/* Estilos para el botón cuando el menú está abierto */\n.menu-button.open {\n  background-color: #dc3545;\n  /* Cambiar a rojo cuando está abierto */\n}\n\n.menu-button svg {\n  color: white;\n  font-size: 1.5rem;\n}\n\n/* Estilos para los elementos del menú */\n.menu-items {\n  background-color: white;\n  border-radius: 10px;\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);\n  opacity: 0;\n  transform: translateY(-20px);\n  transition: all 0.3s ease;\n  pointer-events: none;\n  /* Evita clics cuando está cerrado */\n  padding: 20px;\n  position: absolute;\n  right: 0;\n  top: 70px;\n  width: 200px;\n  display: flex;\n  flex-direction: column;\n}\n\n.menu-items.open {\n  opacity: 1;\n  transform: translateY(0);\n  pointer-events: auto;\n}\n\n.menu-item {\n  padding: 10px 0;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.menu-item:hover {\n  background-color: #f8f9fa;\n  border-radius: 5px;\n}\n\n.menu-item svg {\n  margin-right: 10px;\n  font-size: 1.2rem;\n  color: #007bff;\n}\n\n.menu-item span {\n  font-size: 1rem;\n  color: #343a40;\n}\n\n/* Responsive: Adaptación para pantallas pequeñas */\n@media (max-width: 768px) {\n  .menu-container {\n    top: 10px;\n    right: 10px;\n  }\n\n  .menu-button {\n    width: 50px;\n    height: 50px;\n  }\n\n  .menu-items {\n    width: 150px;\n    top: 60px;\n  }\n}\n\n/* Estilo general para los botones */\n.btn-custom {\n  background-color: #007bff;\n  /* Azul bootstrap */\n  color: #fff;\n  border-radius: 50px;\n  /* Borde redondeado */\n  padding: 10px 20px;\n  /* Espaciado interno del botón */\n  font-size: 16px;\n  /* Tamaño de la fuente */\n  border: none;\n  /* Sin borde */\n  cursor: pointer;\n  transition: background-color 0.3s ease, transform 0.2s ease;\n}\n\n/* Hover: cambia el color cuando pasas el mouse sobre el botón */\n.btn-custom:hover {\n  background-color: #0056b3;\n  /* Azul más oscuro */\n  transform: scale(1.05);\n  /* Aumenta un poco el tamaño */\n}\n\n/* Estilo para botones dentro de los nav-items */\n.nav-item .btn-custom {\n  margin-right: 10px;\n  /* Espaciado entre botones en el menú */\n  text-decoration: none;\n  /* Elimina el subrayado */\n  display: inline-block;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
